<template lang="pug">
  .report
    PCheckbox(v-model="reportOptions.fired" @change="changeCommon" :label="`Considerar ${$wp('employee')} demitidos`")
    .button
      PButton(color="success" size="md" @click="generate()" :loading="loading" :disabled="!valid") gerar arquivo

</template>

<script>
export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        fired: false
      }
    }
  },
  methods: {
    async generate () {
      try {
        await this.$swal({
          type: 'warning',
          title: 'Atenção',
          text: `Para gerar esse relatório com segurança, é necessário que o travamento de folhas tenha sido executado para todos os ${this.$wp('employee')}. Se ainda não realizou, por favor execute o processo e depois gere este arquivo.`,
          showCancelButton: true,
          confirmButtonText: 'Gerar',
          cancelButtonText: 'Cancelar'
        })
      } catch (error) {
        return 'Sair do modal'
      }

      this.loading = true

      let result

      const params = {
        companies: [],
        employees: [],
        employers: [],
        year: this.reportInfo.periodData.year,
        month: this.reportInfo.periodData.month,
        ...this.reportOptions
      }

      if (this.reportInfo.entity === 'companies') {
        params.companies = this.reportInfo.entityContent.map(i => i.id)
      } else if (this.reportInfo.entity === 'employees') {
        params.employees = this.reportInfo.entityContent.map(i => i.id)
      } else if (this.reportInfo.entity === 'employer') {
        params.employers = this.reportInfo.entityContent.map(i => i.id)
      }

      try {
        result = await this.$API.E08.save(params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    },
    changeCommon () {
      if (this.reportOptions.fired) {
        this.$emit('changeCommon', 'employee', 'employees')
      } else {
        this.$emit('changeCommon', 'employee', 'employees/onlyNotFired')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;
  .button {
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
